export const consts = {
  CalendarPageUrl: 'Discovery.Feature.LotPages.SaleNavigationTargets.CalendarPageUrl',
}
